import React, { FC, PropsWithChildren } from "react";
import { Dialog, DialogActionProps } from "react-toolbox/lib/dialog";

import style from "./style.scss";
import { JobberIntegrationCard } from "./JobberIntegrationCard";
import { LACRMIntegrationCard } from "./LACRMIntegrationCard";

export interface IntegrationsListDialogProps {
    appId: string;
    /**
     * Dialog is active
     */
    active?: boolean;
    /**
     * List of integrations to show.
     */
    integrations: string[];
    /**
     * User cancelled the dialog
     */
    onCancel?(): void;
}

export const IntegrationsListDialog: FC<PropsWithChildren<IntegrationsListDialogProps>> = ({
    active,
    appId,
    integrations,
    onCancel
}: IntegrationsListDialogProps) => {

    const dialogActions: DialogActionProps[] = [

        {
            accent: true,
            label: "Done",
            onClick: onCancel
        }
    ];

    return (
        <>
            <Dialog title="Add Integration" active={active} actions={dialogActions}>
                <div className={style.listContainer}>
                    {integrations.includes("lacrm") && (
                        <div style={{ display: "flex", alignItems: "end" }}>
                            <LACRMIntegrationCard
                                appId={appId}
                                isLinked={false}
                            />
                        </div>
                    )}
                    {integrations.includes("jobber") && (
                        <div style={{ display: "flex", alignItems: "end" }}>

                            <JobberIntegrationCard
                                appId={appId}
                                isLinked={false}
                            />
                        </div>
                    )}
                </div>
            </Dialog>
        </>
    )
}